import { BusinessUnitItemSchema } from "../business-unit/business-unit-item";
import { ProductItemSchema } from "../product/product-item";
import { z } from "zod";

export const TrackingListItemSchema = z.object({
  Id: z.string().uuid(),
  DateDelivered: z.string().optional(),
  DateInstalled: z.string().optional(),
  DatePaid: z.string().optional(),
  DateShipped: z.string().optional(),
  DateSold: z.string().optional(),
  DateStarted: z.string().optional(),
  DateCancelled: z.string().optional(),
  DeliveryStatus: z.string().optional(),
  InvoiceCreated: z.boolean().optional(),
  InvoiceSent: z.boolean().optional(),
  LicenseKey: z.string().optional(),
  LicenseKeyStatus: z.string().optional(),
  Name: z.string().optional(),
  PackageCount: z.number().optional(),
  IsPaid: z.boolean().optional(),
  PaidStatusCode: z.number().optional(),
  ProductStatusCode: z.number().optional(),
  ProductStatusName: z.string().optional(),
  Quantity: z.number().optional(),
  SerialNumber: z.string().optional(),
  ShipmentType: z.string().optional(),
  DeliveryStatusDate: z.string().optional(),
  DeliveryStatusLocation: z.string().optional(),
  DeliveryStatusMessage: z.string().optional(),
  DeliveryStatusName: z.string().optional(),
  DeliveryCourier: z.string().optional(),
  TrackingNumber: z.string().optional(),
  Installed: z.boolean().optional(),
  StatusCode: z.number().optional(),
  ProductId: ProductItemSchema.shape.Id.optional(),
  ProductName: z.string().optional(),
  BusinessUnitId: BusinessUnitItemSchema.shape.Id.optional(),
  BusinessUnitName: z.string().optional(),
  Product: ProductItemSchema.optional(),
  IsInstalled: z.boolean().optional(),
  IsNotInstalled: z.boolean().optional(),
});

export type TrackingListItemType = z.infer<typeof TrackingListItemSchema>;
